module.exports = __webpack_public_path__ + "img/dep_medicineandfirstaid@3x.70ee4f76.png";